import { Box, Typography } from '@mui/material';
import React from 'react';

export const SessionTitleHeader: React.FC<{ title: string }> = ({ title }) => (
  <Box
    sx={{
      flex: 1,
      minWidth: 0,
      py: 0.5,
      bgcolor: 'transparent',
    }}
  >
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 600,
        color: 'text.primary',
        fontSize: '0.85rem',
        lineHeight: 1.4,
        wordBreak: 'break-word',
      }}
    >
      {title}
    </Typography>
  </Box>
);
